<template>
    <c-dialog ref="dialog" title="资产领用单详情" mode="slide" width="800" enable-flex mask-close :button="false">
        <template #head>
            <div v-if="detailData.apply_code" class="m-detail-tag flex-center-cross">
                <label>{{detailData.apply_title || detailData.apply_code}}</label>
                <c-state dict="applyStatusDic" tag :value="detailData.apply_status"></c-state>
            </div>
        </template>

		<doc-base>
			<template #title>{{detailData.apply_user_name}}_资产领用单</template>

			<template #info>
				<c-field label="单据编号">{{detailData.apply_code}}</c-field>
			</template>
		</doc-base>

		<doc-content>
			<c-field label="关联工单">{{detailData.aftersale_order_code}}</c-field>
			<c-field label="计划使用时间">{{detailData.plan_use_time}}</c-field>
			<c-field label="预计归还时间">{{detailData.plan_return_time}}</c-field>
			<c-field label="领用资产明细" vertical>
                <c-table :data="detailData.item_list" border :paging="false">
                    <c-table-column
                        label="资产编号"
                        name="asset_code"
                        width="120"
                    ></c-table-column>
                    <c-table-column
                        label="资产名称"
                        name="asset_name"
                    ></c-table-column>
                    <c-table-column
                        label="资产分类"
                        name="asset_category"
                    ></c-table-column>
                    <c-table-column
                        label="领用数量"
                    >
                        <template #default="{data}">
                            {{data.receive_quantity}}{{data.unit_name}}
                        </template>
                    </c-table-column>
					<c-table-column
                        label="凭证"
                        width="300"
                    >
                        <template #default="{data}">
						    <c-file-list :value="data.voucher_image_url"></c-file-list>
                        </template>
					</c-table-column>
                </c-table>
			</c-field>
			<c-field label="备注">{{detailData.remark}}</c-field>
		</doc-content>

		<doc-handle
			ref="docHandle"
			:status="detailData.apply_status"
			:applicant="detailData.is_founder == 1"
			@update="getDetail"
		></doc-handle>
    </c-dialog>
</template>

<script>
export default {
    name: 'assetReceiveApplyDetail',
    
    props: {
        id: [String, Number]
    },

    data() {
        return {
            detailData: {}
        }
    },

    methods: {
        open() {
            this.getDetail();
            this.$refs.dialog.open();
        },

        getDetail() {
            this.request({
                url: '/asset_receive_apply/detail',
                data: {
                    id: this.id
                },
                loading: true,
                success: data => {
                    this.detailData = data;
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
